/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IGridRoom {
        id: number;
        href: string;
        name: string;
        pages: IGridPage[];
        creationDate: Date;
        monitors?: IMonitor[]; // not used. legacy property from old monitoringRoom
        defaultForOrganizationId: number;
        alias?: string;
    }

    export interface IGridPage {
        id: number;
        href: string;
        columns: number;
        rows: number;
        numOrder: number;
        monitors: IGridMonitor[];
        trending?: boolean;
    }

    export interface IGridMonitor {
        id: number;
        href: string;
        row: number;
        column: number;
        source: number;
        sourceName: string;
        sourceNode: string;
        sink: number | string;
        sinkName: string;
        sinkNode: string;
        type: string;
        switchId?: string;
        videoFeed: VideoFeed;
        sinkBlock: IBlock;
    }

    export interface IMonitorPageGrid {
        monitorRoom: {
            name: string;
            creationDate: Date;
        };
        monitorPage: IGridPage;
        streamPipesMap: { [key: number]: IGridStreamPipe };
    }

    export interface IGridStreamPipe extends IStreamPipe {
        links: {[key: string]: string}[];
    }

    export class GridRoom implements IGridRoom {
        public id: number;
        public href: string;
        public pages: IGridPage[];
        public name: string;
        public creationDate: Date;
        public monitors: IMonitor[];
        public defaultForOrganizationId: number;
        public alias: string;
        
        public static Empty(): GridRoom {
            return new GridRoom();
        }

        constructor() {
            this.id = undefined;
            this.href = '';
            this.name = '';
            this.pages = undefined;
            this.creationDate = undefined;
            this.monitors = undefined;
            this.defaultForOrganizationId = undefined;
            this.alias = '';
        }
    }

    export class GridPage implements IGridPage {
        public id: number;
        public href: string;
        public columns: number;
        public rows: number;
        public numOrder: number;
        public monitors: IGridMonitor[];

        public static Empty(): GridPage {
            return new GridPage();
        }

        constructor() {
            this.id = undefined;
            this.href = undefined;
            this.columns = undefined;
            this.rows = undefined;
            this.numOrder = undefined;
            this.monitors = undefined;
        }
    }

    export class GridMonitor implements IGridMonitor {
        public id: number;
        public href: string;
        public row: number;
        public column: number;
        public source: number;
        public sourceName: string;
        public sourceNode: string;
        public sink: number | string;
        public sinkName: string;
        public sinkNode: string;
        public type: string;
        public switchId?: string;
        public videoFeed: VideoFeed;
        public sinkBlock: IBlock;

        public static Empty(): GridMonitor {
            return new GridMonitor();
        }

        constructor() {
            this.id = undefined;
            this.href = undefined;
            this.row = undefined;
            this.column = undefined;
            this.source = undefined;
            this.sourceName = undefined;
            this.sourceNode = undefined;
            this.sink = undefined;
            this.sinkName = undefined;
            this.sinkNode = undefined;
            this.switchId = undefined;
        }
    }

    // export class GridStreamPipe implements IGridStreamPipe {
    //     public active: boolean;
    //     public errorCode: boolean;
    //     public sourceInputLevels: string[];
    //     public sinkOutputLevels: string[];
    //     public sourceNodeHref: number;
    //     public sourceBlock: { present: boolean; }
    //     public sinkNodeHref: number;
    //     public sinkBlock: { present: boolean; };
    //     public href: string;

    //     public static Empty(): GridStreamPipe {
    //         return new GridStreamPipe();
    //     }

    //     constructor() {
    //         this.active = undefined;
    //         this.errorCode = undefined;
    //         this.sourceInputLevels = undefined;
    //         this.sinkOutputLevels = undefined;
    //         this.sourceNodeHref = undefined;
    //         this.sourceBlock = undefined;
    //         this.sinkNodeHref = undefined;
    //         this.sinkBlock = undefined;
    //         this.href = undefined;
    //     }
    // }
}